// Hook danych wysyłki aktualnej wersji oferty – GET /sales-crm/clients/:cid/offers/:oid/shipping

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmOfferShipping {
  warehouseId: number | null;
  deliveryMethodId: number | null;
  deliveryDate: string | null;
  carrierName: string | null;
  deliveryCost: number | null;
  receiverId: number | null;
  splitDeliveryCost: boolean | null;
}

const getSalesCrmOfferShipping = (
  clientId: number,
  offerId: string,
  versionId?: number | null
): Promise<ISalesCrmOfferShipping> =>
  axios.get(`/sales-crm/clients/${clientId}/offers/${offerId}/shipping`, {
    params: versionId ? { versionId } : undefined
  });

export const useGetSalesCrmOfferShipping = (
  clientId: number,
  offerId: string,
  versionId?: number | null,
  options?: UseQueryOptions<ISalesCrmOfferShipping, IError>
) =>
  useQuery<ISalesCrmOfferShipping, IError>(
    ['sales-crm', 'client', clientId, 'offer', offerId, 'shipping', versionId ?? 'actual'],
    () => getSalesCrmOfferShipping(clientId, offerId, versionId),
    {
      ...options,
      enabled:
        options?.enabled !== false && clientId > 0 && String(offerId).trim().length > 0
    }
  );
